import React, { Component } from "react";
import { Table, Image, Button, Tag, Progress, Switch } from "antd";
import ImageWall from "./ImageWall";
import AssessmentTag from "../../components/AssessmentTag";
import ImageListPreview from "../../components/ImageListPreview";

const renderImagePreview = (r) => {
  return (
    <Image.PreviewGroup style={{ display: "flex", flexDirection: "row" }}>
      <Image
        height={50}
        alt={r["title"]}
        src={r["thumbnail url"]}
        fallback="https://www.fluttercampus.com/img/4by3.webp"
      />
    </Image.PreviewGroup>
  );
};

const orderedTag = (tag) => {
  var n = 10;
  switch (tag) {
    case "High-res":
      n = "01";
      break;

    case "Mid-res":
      n = "02";
      break;

    case "Low-res":
      n = "03";
      break;

    default:
      n = "10";
      break;
  }
  return n + tag;
};

const shortenText = (t) => {
  const maxNumberOfChar = 30;
  var text = t.slice(5);
  if (text.length > maxNumberOfChar) {
    text = text.slice(0, maxNumberOfChar) + "...";
  }

  return text;
};

const columns = [
  {
    title: "Preview",
    dataIndex: "thumbnail url",
    key: "thumbnail url",
    render: (t, r) => (
      <ImageListPreview images={[r]} width={""} height={50}></ImageListPreview>
    ),
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    width: "40%",
    render: (t, r) => (
      <Button target="_blank" type="link" href={r["page url"]}>
        {shortenText(t)}
      </Button>
    ),
    sorter: {
      compare: (a, b) => orderedTag(a.title).localeCompare(orderedTag(b.title)),
      multiple: 1,
    },
    defaultSortOrder: "ascend",
  },
  {
    title: "Type",
    dataIndex: "file_type",
    key: "file_type",
    width: "10%",
    render: (t, r) => <AssessmentTag type="file type" text={r.file_type} />,
  },
  {
    title: "Repetitions",
    dataIndex: "repetitions",
    key: "repetitions",
    width: "10%",
    sorter: {
      compare: (a, b) => a.repetitions - b.repetitions,
      multiple: 4,
    },
    defaultSortOrder: "descend",
  },
  {
    title: "Resolution",
    dataIndex: "resolution",
    key: "resolution",
    width: "10%",
    render: (t, r) => <AssessmentTag type="resolution" text={r.resolution} />,
    sorter: {
      compare: (a, b) =>
        orderedTag(a.resolution).localeCompare(orderedTag(b.resolution)),
      multiple: 5,
    },
    defaultSortOrder: "descend",
  },
  {
    title: "Width",
    dataIndex: "width",
    key: "width",
    width: "10%",
    sorter: {
      compare: (a, b) => a.width - b.width,
      multiple: 3,
    },
    defaultSortOrder: "ascend",
  },
  {
    title: "Height",
    dataIndex: "height",
    key: "height",
    width: "10%",
    sorter: {
      compare: (a, b) => a.height - b.height,
      multiple: 2,
    },
    defaultSortOrder: "ascend",
  },
];

export default class ArticlesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOnlyImages: false,
    };
  }

  onChangeSwitch = (checked) => {
    this.setState({
      showOnlyImages: checked,
    });
  };

  render() {
    const { showOnlyImages } = this.state;
    return (
      <>
        <span>
          <b>{this.props.data.length} Images</b> (total <span> </span>
          {this.props.numberOfArticles})
        </span>
        <span>
          Show only images<span> </span>
          <Switch onChange={this.onChangeSwitch} />
        </span>

        <Progress
          percent={(this.props.data.length / this.props.numberOfArticles) * 100}
          size="small"
          status="active"
          showInfo={false}
        />
        <div style={{ height: "20px", width: "100%" }}></div>
        {(() => {
          if (showOnlyImages) {
            return <ImageWall data={this.props.data}></ImageWall>;
          } else {
            return (
              <Table
                style={{ width: "100%" }}
                bordered
                dataSource={this.props.data}
                columns={columns}
                pagination={{ position: ["bottomCenter"] }}
              />
            );
          }
        })()}
      </>
    );
  }
}
